<template>
  <div class="page-helper">
    <div class="btn-box">
      <a-button :disabled="preDisabled" class="btn" @click="handlePrevious">上一页</a-button>
      <a-button :disabled="nextDisabled" class="btn" @click="handleNext">下一页</a-button>
    </div>
  </div>
</template>

<script>
export default {
 props:{
   'preDisabled':Boolean,
   'nextDisabled':Boolean
 },
  data() {
    return {}
  },
  created(){

  },
  methods:{
    handlePrevious() {
      
      this.$emit('previous')
    },
    handleNext() {
 
      this.$emit('next')
    }
  }
}
</script>

<style lang="less" scoped>
.page-helper {
  margin-top: 20px;
  height: 50px;
  width: 100%;
  margin-bottom: 20px;
  .btn-box {
    float: right;
    .btn {
      margin-left: 20px;
    }
  }
}
</style>
